import { ModelResponse } from "../../core/services/ModelResponse";
    
  export class DataWarehouseWorkspaceModelResponse extends ModelResponse<any> {
      static readonly $typeName = 'DataWarehouseWorkspaceModel';
      public metaData: any;
      public isClone?: boolean;
  }



// WEBPACK FOOTER //
// ./src/app/datawarehouse/models/DataWarehouseWorkspaceModelResponse.ts